// utilities/errorHandler/friendly.ts - utilities/errorHandler.ts split (sub-module friendly)


import { isChunkLoadError } from './checks.js';
import { isNetworkError } from './checks.js';
import { isTimeoutError } from './checks.js';


// ============== Helper Functions ==============

/**
 * Creates a user-friendly error message from various error types
 */
export function getUserFriendlyMessage(
  error: unknown,
  defaultMessage: string,
  context?: string
): string {
  if (error instanceof Error) {
    // Handle chunk loading errors (stale deploy — module hash mismatch)
    if (isChunkLoadError(error)) {
      return `Aplikasi perlu dimuat ulang. Reload halaman untuk mendapatkan versi terbaru.`;
    }

    // Handle network errors
    if (isNetworkError(error)) {
      return `Gagal terhubung ke server. ${context ? context + ". " : ""}Periksa koneksi internet Anda.`;
    }
    
    // Handle timeout errors
    if (isTimeoutError(error)) {
      return `Permintaan habis waktu. Silakan coba lagi.`;
    }
    
    // Handle HTTP errors
  const err = error as any;
  if ("status" in err && typeof err.status === "number") {
      const status = err.status;
      switch (status) {
        case 401:
        case 403:
          return "Akses ditolak. Silakan login kembali.";
        case 404:
          return "Data tidak ditemukan.";
        case 429:
          return "Terlalu banyak permintaan. Silakan tunggu sebentar.";
        case 500:
        case 502:
        case 503:
          return "Server mengalami masalah. Silakan coba lagi nanti.";
        default:
          return error.message || defaultMessage;
      }
    }
    
    return error.message || defaultMessage;
  }
  
  if (typeof error === "string") {
    return error;
  }
  
  return context ? `${defaultMessage} (${context})` : defaultMessage;
}
